// @ts-nocheck
import { GeoDictionary } from 'mercator-cartography-api-client/lib/interfaces/geoDictionary.types';
import { request } from 'sonata-react-components';
import { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';
import { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

import { CampaignItem } from '@/ts-modules/reporting/CampaignListSelector/CampaignListSelector';

export async function getCampaignsData(
  campaignIds: string[],
  userId: string,
  token?: Record<string, any>
): Promise<CampaignItem[]> {
  return request.makeRequest(
    `${taptap.config.backendUrlBase}report/campaignsData`,
    {
      data: {
        campaignIds: campaignIds.join(','),
        userId
      },
      method: 'POST'
    },
    token
  );
}

export async function getCampaignsAdActions(campaignIds: string[], token?: Record<string, any>): Promise<string[]> {
  return request.makeRequest(
    `${taptap.config.backendUrlBase}report/campaignsAdActions`,
    {
      method: 'GET',
      params: {
        campaignIds: campaignIds.join(',')
      }
    },
    token
  );
}

export async function getBaseCurrencies(token?: Record<string, any>): Promise<BaseCurrencyInterface[]> {
  return request.makeRequest(`${taptap.config.backendUrlBase}baseCurrency/catalog`, { method: 'GET' }, token);
}

export async function getUserRoles(token?: Record<string, any>): Promise<UserRoleInterface[]> {
  return request.makeRequest(`${taptap.config.backendUrlBase}usersRoles`, { method: 'GET' }, token);
}

export async function getCartographyDictionary(
  countries: string[],
  requestToken?: Record<string, any>
): Promise<GeoDictionary[]> {
  return request.makeRequest(
    `${taptap.config.backendUrlBase}cartography/dictionary`,
    {
      params: {
        countries,
        inEvents: true
      }
    },
    requestToken
  );
}

export async function getAIInsightsFromStats(
  cids: string[],
  metrics: string[],
  dimensions: string[],
  language: string,
  dateInterval: {
    end: string;
    start: string;
    timezone: string;
  },
  token: Record<string, any>
): Promise<string> {
  const aiResponse = await request.makeRequest(
    `${taptap.config.backendUrlBase}ai/insightsFromStats`,
    {
      data: {
        cids,
        dateInterval,
        dimensions,
        language,
        metrics
      },
      method: 'POST'
    },
    token
  );
  return aiResponse.result;
}
